import { useCallback } from 'react';
import { useAuthStore } from '@/store/authStore';
import { useUiStore } from '@/store/uiStore';

/**
 * Central download trigger. Signed-in users see a short ad interstitial before
 * the file opens (our monetization for the unlimited tier); guests download
 * directly. Both paths are user-gesture initiated so browsers don't block them.
 */
export function useDownloadAction() {
  const openAdGate = useUiStore((s) => s.openAdGate);

  return useCallback(
    (url: string, title: string) => {
      const signedIn = Boolean(useAuthStore.getState().user);
      if (signedIn) {
        openAdGate({ url, title });
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    },
    [openAdGate]
  );
}
